import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "../../layout/AppLayout";
import { Alert } from "../../components/erp";
import { errorText } from "../../api/client";
import { verificationApi } from "./api";

/** Port of v3/QualityControl/RmAnalysisPreview.php — final verification (Remarks + Deductions) into QcRmOrgnReport. */
export default function AnalysisPreview() {
  const [params] = useSearchParams();
  const lotId = params.get("LotId") || "";
  const existing = useQuery({ queryKey: ["qc", "verification", lotId], queryFn: () => verificationApi.get(lotId), enabled: !!lotId });
  const [remarks, setRemarks] = useState("");
  const [deductions, setDeductions] = useState("");
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (existing.data?.Data) { setRemarks(existing.data.Data.Remarks || ""); setDeductions(existing.data.Data.ActualDeductions || ""); }
  }, [existing.data]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setSaving(true); setMsg(null);
    try {
      const r = await verificationApi.post(lotId, { Remarks: remarks, LabDeductions: deductions });
      setMsg(r.Error ? { ok: false, text: r.Error } : { ok: true, text: "Verification saved." });
    } catch (ex) { setMsg({ ok: false, text: errorText(ex) }); } finally { setSaving(false); }
  };

  return (
    <>
      <PageHeader title="RM Analysis — Verification" location="Quality Control" />
      <div className="card" style={{ maxWidth: 560 }}><div className="card-body">
        <p className="mb-3">Lot ID: <strong data-testid="verification-lot-id">{lotId}</strong></p>
        <form onSubmit={submit} data-testid="verification-form">
          <div className="mb-3"><label className="form-label">Remarks</label>
            <textarea className="form-control" value={remarks} onChange={(e) => setRemarks(e.target.value)} data-testid="verification-remarks" /></div>
          <div className="mb-3"><label className="form-label">Lab Deductions</label>
            <input className="form-control" value={deductions} onChange={(e) => setDeductions(e.target.value)} data-testid="verification-deductions" /></div>
          {msg && <Alert kind={msg.ok ? "success" : "danger"} testId="verification-msg">{msg.text}</Alert>}
          <button className="btn btn-primary" type="submit" disabled={saving} data-testid="verification-submit">{saving ? "Saving..." : "Submit Verification"}</button>
        </form>
      </div></div>
    </>
  );
}
